import * as z from 'zod';
import { ContractSuretyType, contractDamageSchema, contractHazardSchema, usStateOrTerritorySchema } from '../../../../enums.mjs';
import { suretyBondId, isoDateSchema, naicsCodeId, city } from '../../../opaque.mjs';
import { currencySchema, safeNumberSchema, positiveCurrencySchema } from '../../../utils.mjs';
import { Underwriting as Underwriting$1 } from './contract-surety-quote.types.mixins.mjs';

var Underwriting;
(function (Underwriting) {
    Underwriting.schema = z.object({
        contractSuretyType: z.literal(ContractSuretyType.bid_to_final),
        bond: Underwriting$1.Bond.baseSchema.extend({
            calculations: z.object({
                daysFromBidToContractDate: safeNumberSchema.nullish(),
                bidSpread: safeNumberSchema.nullish(),
                actualToRequestedBidSpread: safeNumberSchema.nullish(),
                potentialPrincipalAggregateExposure: currencySchema,
            }),
        }),
        project: Underwriting$1.Project.schema,
    });
})(Underwriting || (Underwriting = {}));
var Bond;
(function (Bond) {
    Bond.schema = z.object({
        bidBondId: suretyBondId,
        contractAmount: currencySchema,
        actualBidAmount: positiveCurrencySchema.nullish(),
        secondBid: positiveCurrencySchema.nullish(),
        contractDate: isoDateSchema.nullish(),
        actualBidDate: isoDateSchema.nullish(),
        completionBond: z.boolean().nullish(),
    });
})(Bond || (Bond = {}));
var Project;
(function (Project) {
    Project.schema = z.object({
        name: z.string().min(1),
        projectNumber: z.string().nullish(),
        description: z.string().nullable(),
        address: z
            .object({
            city: city.nullish(),
            state: usStateOrTerritorySchema.nullish(),
        })
            .nullish(),
        scopeOfWork: z.array(naicsCodeId),
        monthsToComplete: safeNumberSchema.min(1).nullable(),
        contractWarrantyMonths: safeNumberSchema.nonnegative().nullable(),
        contractHazards: z.array(contractHazardSchema).default([]),
        contractDamages: z.array(contractDamageSchema).default([]),
    });
})(Project || (Project = {}));
var Data;
(function (Data) {
    Data.schema = z.object({
        suretyType: z.literal("contract"),
        contractSuretyType: z.literal(ContractSuretyType.bid_to_final),
        bond: Bond.schema,
        project: Project.schema,
    });
})(Data || (Data = {}));
var Details;
(function (Details) {
    Details.schema = z.object({
        contractSuretyType: z.literal(ContractSuretyType.bid_to_final),
        bidBondId: suretyBondId,
        contractAmount: currencySchema,
        actualBidAmount: positiveCurrencySchema,
        secondBid: positiveCurrencySchema.nullable(),
        contractDate: isoDateSchema.nullable(),
        actualBidDate: isoDateSchema.nullable(),
        underwriting: Underwriting.schema,
    });
})(Details || (Details = {}));

export { Bond, Data, Details, Project, Underwriting };
